import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: false,
  template: `
    <button
      class="btn d-flex align-items-center position-relative"
      [type]="type"
      [class]="cssClasses"
      [title]="title"
      [disabled]="disabled"
      (click)="clicked.emit($event)"
      [tabindex]="tabindex"
      >
      <span class="material-symbols-outlined" [style.fontSize]="iconFontSize">
        {{ icon }}
      </span>
      @if (showBadge) {
        <span
          class="position-absolute top-0 start-0 translate-middle badge rounded-pill"
          [class]="badgeClass"
          >
          {{ badgeContent }}
        </span>
      }
    </button>
    `,
  styleUrls: ['./icon-button.component.scss'],
  selector: 'ideapa-icon-button',
})
export class IconButtonComponent {
  @Input()
  cssClasses? = '';

  @Input()
  type = 'button';

  @Input()
  icon = '';

  @Input()
  disabled? = false;

  @Input()
  title = '';

  @Input()
  tabindex? = '';

  @Input()
  iconFontSize = '24px';

  @Input()
  badgeContent?: any;

  @Input()
  badgeClass = 'bg-danger';

  @Output()
  clicked = new EventEmitter<Event>();

  get showBadge() {
    return !!this.badgeContent;
  }
}
